import React from "react";
import { Element } from "./typography.styles";
import { ITypography } from "./typography.type";

const Typography: React.FC<ITypography> = ({
  as = "p",
  children,
  ...props
}) => {
  return (
    <Element as={as} {...props}>
      {children}
    </Element>
  );
};

export default Typography;
